<template>
  <q-list>
    <q-item-label header>{{ t('nav.navigation') }}</q-item-label>

    <q-item to="/" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="home" /></q-item-section>
      <q-item-section>{{ t('nav.home') }}</q-item-section>
    </q-item>

    <q-item to="/about" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="info" /></q-item-section>
      <q-item-section>{{ t('nav.about') }}</q-item-section>
    </q-item>

    <q-item v-if="!loggedIn" to="/login" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="login" /></q-item-section>
      <q-item-section>{{ t('nav.login') }}</q-item-section>
    </q-item>

    <!-- Разделитель для авторизованных пользователей -->
    <q-separator v-if="loggedIn" class="q-my-md" />
    <q-item-label v-if="loggedIn" header>{{ t('nav.facebook_section') }}</q-item-label>

    <q-item v-if="loggedIn" to="/facebook-accounts" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="facebook" /></q-item-section>
      <q-item-section>
        <q-item-label>{{ t('nav.facebook_accounts') }}</q-item-label>
        <q-item-label caption>{{ t('nav.facebook_accounts_desc') }}</q-item-label>
      </q-item-section>
    </q-item>

    <q-item v-if="loggedIn" to="/facebook-conversions" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="analytics" /></q-item-section>
      <q-item-section>
        <q-item-label>{{ t('nav.facebook_conversions') }}</q-item-label>
        <q-item-label caption>{{ t('nav.facebook_conversions_desc') }}</q-item-label>
      </q-item-section>
    </q-item>

    <!-- Разделитель для админа -->
    <q-separator v-if="loggedIn && isAdmin" class="q-my-md" />
    <q-item-label v-if="loggedIn && isAdmin" header>{{ t('nav.admin_section') }}</q-item-label>

    <q-item v-if="loggedIn && isAdmin" to="/admin/users" tag="router-link" clickable>
      <q-item-section avatar><q-icon name="group" /></q-item-section>
      <q-item-section>
        <q-item-label>{{ t('nav.users') }}</q-item-label>
        <q-item-label caption>{{ t('nav.users_desc') }}</q-item-label>
      </q-item-section>
    </q-item>

    <!-- Разделитель для выхода -->
    <q-separator v-if="loggedIn" class="q-my-md" />

    <q-item v-if="loggedIn" clickable @click="logout">
      <q-item-section avatar><q-icon name="logout" /></q-item-section>
      <q-item-section>{{ t('nav.logout') }}</q-item-section>
    </q-item>
  </q-list>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const authStore = useAuthStore()
const router = useRouter()

const user = computed(() => authStore.user)
const loggedIn = computed(() => !!authStore.token)
const isAdmin = computed(() => user.value?.role === 'admin')

function logout() {
  authStore.logout()
  router.push('/login')
}
</script>